<template>
    <LayoutSub :parent="this.$route.path?.split('/')[2]" className="sales">
        <SubpageTitleContainer :title="`이지샵 매출관리`" :subText="`이지샵 매출관리를 통해 카드 매출내역부터 입금내역까지 한 곳에서 간편하게 관리할 수 있습니다.`">
        </SubpageTitleContainer>

        <SubSection class="pt-0">
            <div class="grid-3 scroll">
                <CardBox idx="1" title="가맹점 매출정산"
                    :list="['실시간 카드/현금 등 거래내역 조회', '일별/월별/카드사별/매장별 매출집계', '다양한 검색 조건과 조회 항목 ']" />
                <CardBox idx="2" title="카드사 입금 예정/반송 자료" :list="[
                    '자동매입(DDC)/수기매입(EDI) 결과 조회',
                    '입금 누락 방지를 위한 카드사 반송내역',
                    '카드사 수수료율 조회 (여신협회 연동)  ',
                ]" />
                <CardBox idx="3" title="가맹점 직접매입(EDI) 청구 기능"
                    :list="['파일 업로드, 건별 청구 기능 지원', '17개의 검색조건과 33개의 조회 항목 제공', '작업오류 모니터링 운영인력 구성']" />
            </div>
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">특징</SubTitle3>
            <div class="content">
                <TableRow :title="`실시간 매출확인`" :content="`실시간 카드, 현금영수증 거래내역/다양한 매출집계/실시간 매출, 어제 매출, 입금 예정액 간편 조회`"
                    :src="`sale_manager_icon1.png`" />
                <TableRow :title="`카드사 입금/반송 자료`" :content="`거래건별 입금예정금액 확인/다양한 입금예정집계/입금 누락 방지 매출보류, 입금보류 확인`"
                    :src="`sale_manager_icon2.png`" />
                <TableRow :title="`다양한 리포트`" :content="`고객에게 바로 전송 가능한 영수증 이미지 제공/부가세신고에 도움을 주는 부가세참조자료`"
                    :src="`sale_manager_icon3.png`" />
                <TableRow :title="`이지샵 모바일`"
                    :content="`우리가게 매출, 입금 일일 리포트/시간대별, 월별, 요일별 매출분석 그래프/최고 매출 금액, 최고 매출일자 매출분석`"
                    :src="`sale_manager_icon4.png`" />
            </div>
        </SubSection>

        <SubSection class="pb-0">
            <SubTitle3 listStyle="dot">이지샵 모바일(EasyShop Mobile)</SubTitle3>
            <div class="mobile-easy-shop content">
                <div class="left_area">
                    <img src="@/assets/sale_manager_image1.png" alt="" />
                </div>
                <div class="right_area">
                    <div class="row">
                        <div class="area_num">01</div>
                        <div class="area_block">
                            <div class="area_title">서비스 안내</div>
                            <p>
                                IOS APP 이지샵 모바일 (모든 메뉴 무료 서비스)<br />
                                특화 메뉴 : 실시간 집계,그래프로 보는 매출분석, 입금누락방지를 위한 매출/입금 보류 내역
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="area_num">02</div>
                        <div class="area_block">
                            <div class="area_title">주요 기능</div>
                            <div class="list_block">
                                <ul>
                                    <li>- 다양한 메뉴 구성, 손쉬운 사용</li>
                                    <li>- 웹사이트 주요 서비스 동일 제공</li>
                                    <li>- 입금누락방지를 위한 미매입 내역</li>
                                </ul>
                                <ul>
                                    <li>- 부가세신고를 위한 참조자료 이미지</li>
                                    <li>- 그래프 형태의 시간대/요일별 등 매출분석</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="app_download_wrap">
                        <button>
                            <a href="https://play.google.com/store/apps/details?id=kr.co.kicc.easyshop&hl=ko"
                                target="_blank">
                                <img src="@/assets/google_play_down.png" alt="" />
                            </a>
                        </button>
                        <button>
                            <a href="https://apps.apple.com/kr/app/easyshop-mobile/id486312603" target="_blank">
                                <img src="@/assets/app_store_down.png" alt="" />
                            </a>
                        </button>
                    </div>
                </div>
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import CardBox from '@/components/CardBox.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow from '@/components/TableRow.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        SubSection,
        SubTitle3,
        CardBox,
        TableRow,
    },
};
</script>